// extracted by mini-css-extract-plugin
export var container = "_404-module--container--8525d";
export var heading = "_404-module--heading--9d3f6";
export var paragraph = "_404-module--paragraph--541ff";